import SectionsData from "modules/shared/profiles/SectionsData";
import { SectionContainer } from "modules/shared/profiles/ViewPaymentInfo";
import React from "react";

function ViewPersonalInfo({ supplierData }) {
    return (
        <SectionContainer>
            <SectionsData
                label="Name(Arabic)"
                text={supplierData?.name}
            />
            <SectionsData
                label="Mobile Number"
                text={supplierData?.phoneNumber}
            />
            <SectionsData
                label="Email"
                text={supplierData?.email ? supplierData?.email : "No data"}
            />
            <SectionsData
                label="National ID Number"
                text={supplierData?.nationalId}
            />
            <SectionsData
                label="ID Photo - Face"
                image={supplierData?.nationalIdFace ? supplierData?.nationalIdFace : "No data"}
            />
            <SectionsData
                label="ID Photo - Back"
                image={supplierData?.nationalIdBack ? supplierData?.nationalIdBack : "No data"}
            />
            <SectionsData
                label="Supplier Picture"
                image={supplierData?.picture ? supplierData?.picture : "No data"}
            />
        </SectionContainer>
    );
}

export default ViewPersonalInfo;
